import {EmailInputView} from "./EmailInputView.js";
import {SignUpViewChanger} from "../util/view-changer/index.js";


export class BusinessEmailView extends  EmailInputView {
    renderComponents() {
        super.renderComponents();
        this.renderGuestPageButton();
    }
    getNextButtonText() {
        return "무료체험 시작하기";
    }
    renderGuestPageButton() {
        const {guestPageButtonText = ''} = this.$props;
        this.getMainContentsLayer().append(`<a class="js-move-guest-page-button" href="#">${guestPageButtonText}</a>`)
    }

    setEvent() {
        super.setEvent();
        this.addEvent("click.stop.prevent", ".js-move-guest-page-button", () => {
            SignUpViewChanger.loadGuestEmailView();
        })
    }
}